import { keyGenerator } from '@/utils/keyGenerator';
import { Pressable, SxProp, View } from 'dripsy';
import React, { useEffect, useState } from 'react';
import { TextBody } from '../typography';

interface CurrencySelectorProps {
  options?: string[];
  activeColor?: string;
  inactiveColor?: string;
  onValueChange: (value: string) => void;
  sx?: SxProp;
}

export const CurrencySelector: React.FC<CurrencySelectorProps> = ({ options, activeColor, inactiveColor, onValueChange, sx }) => {
  const DEFAULT_OPTIONS = ['USD', 'HKD'];
  const OPTIONS = options || DEFAULT_OPTIONS;
  const [selected, setSelected] = useState(0);

  useEffect(() => {
    onValueChange && onValueChange(OPTIONS[selected]);
  }, [selected]);

  return (
    <View sx={{ ...styles.container, ...sx }}>
      {OPTIONS.map((option, index) => {
        return (
          <CurrencySelectorItem
            key={keyGenerator('currencySelector')}
            isFirst={index === 0}
            isLast={index === OPTIONS.length - 1}
            label={option}
            isSelected={selected === index}
            activeColor={activeColor}
            inactiveColor={inactiveColor}
            onPress={() => {
              console.log('@onPress', index);
              setSelected(index);
            }}
          />
        );
      })}
    </View>
  );
};

const CurrencySelectorItem = ({
  label,
  isFirst,
  isLast,
  isSelected,
  activeColor,
  inactiveColor,
  onPress
}: {
  label: string;
  isFirst: boolean;
  isLast: boolean;
  isSelected: boolean;
  activeColor?: string;
  inactiveColor?: string;
  onPress: () => void;
}) => {
  const DEFAULT_ACTIVE_COLOR = '$borderCurrencySelectedActive';
  const DEFAULT_INACTIVE_COLOR = '$borderCurrencySelector';

  const ACTIVE_COLOR = activeColor || DEFAULT_ACTIVE_COLOR;
  const INACTIVE_CLOLOR = inactiveColor || DEFAULT_INACTIVE_COLOR;

  return (
    <Pressable
      sx={{
        ...styles.button,
        borderColor: isSelected ? ACTIVE_COLOR : INACTIVE_CLOLOR,
        borderTopLeftRadius: isFirst ? 5 : 0,
        borderBottomLeftRadius: isFirst ? 5 : 0,
        borderTopRightRadius: isLast ? 5 : 0,
        borderBottomRightRadius: isLast ? 5 : 0
      }}
      onPress={onPress}>
      <TextBody
        sx={{
          color: isSelected ? ACTIVE_COLOR : '$textPrimary'
        }}>
        {label}
      </TextBody>
    </Pressable>
  );
};

enum StyleName {
  container = 'container',
  button = 'button'
}

const styles: Record<StyleName, SxProp> = {
  container: {
    height: '$9',
    width: 'fit-content',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  button: {
    flex: 1,
    height: '$9',
    padding: '$3',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'transparent',
    borderWidth: 1
  }
};
